<template>
  <el-dialog width="700px" append-to-body title="编辑发票抬头" :visible.sync="visible" :before-close="handleClose">
    <el-form class="xm-form" autoComplete="on" :model="header" v-loading="loading" :rules="headerRules"
      element-loading-text="给我一点时间" label-position="right" ref="header" label-width="150px" label-suffix="：">

      <el-form-item label="发票类型" prop="type">
        <el-radio-group v-model="header.type">
          <el-radio :label="0">普通发票</el-radio>
          <el-radio :label="1">增值税专用发票</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="抬头类型" prop="header_type">
        <el-radio-group v-model="header.header_type">
          <el-radio :label="0">个人</el-radio>
          <el-radio :label="1">企业</el-radio>
          <el-radio :label="2">事业单位</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="发票抬头" prop="name">
        <el-input type="text" style="width:350px" v-model="header.name" placeholder="请输入发票抬头"> </el-input>
      </el-form-item>
      <template v-if="header.header_type > 0">
        <el-form-item label="纳税人识别号" prop="tax_no">
          <el-input type="text" style="width:350px" v-model="header.tax_no" placeholder="请输入纳税人识别号">
          </el-input>
        </el-form-item>
        <el-form-item label="开户银行名称" prop="bank_name">
          <el-input type="text" style="width:350px" v-model="header.bank_name" placeholder="请输入开户银行名称">
          </el-input>
        </el-form-item>
        <el-form-item label="开户银行账号" prop="bank_account">
          <el-input type="text" style="width:350px" v-model="header.bank_account" placeholder="请输入开户银行账号">
          </el-input>
        </el-form-item>
        <el-form-item label="营业场所地址" prop="address">
          <el-input type="text" style="width:350px" v-model="header.address" placeholder="请输入营业场所地址">
          </el-input>
        </el-form-item>
        <el-form-item label="注册固定电话" prop="tel">
          <el-input type="text" style="width:350px" v-model="header.tel" placeholder="请输入注册固定电话">
          </el-input>
        </el-form-item>
      </template>
      <el-form-item label="备注" prop="remark">
        <el-input type="text" style="width:350px" v-model="header.remark" placeholder="请输入备注">
        </el-input>
      </el-form-item>
      <el-form-item label="是否默认" prop="is_default">
        <el-switch v-model="header.is_default" :active-value="1" :inactive-value="0">
        </el-switch>
      </el-form-item>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button v-waves type="primary" @click.native.prevent="handleEditHeader" :loading="loading">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveHeader } from '@/api/header'
import waves from '@/directive/waves' // 水波纹指令
export default {
  name: 'EditHeader',
  components: {

  },
  directives: {
    waves
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    oldHeader: {
      type: Object,
      required: true
    }
  },
  watch: {
    visible(value) {
      if (value) {
        const _header = this.oldHeader;
        this.header = JSON.parse(JSON.stringify(_header));
      }
    }
  },
  data() {
    return {
      loading: false,
      header: {
        id: 0,
        name: '',
        type: 0,
        header_type: 0,
        bank_name: '',
        bank_account: '',
        tax_no: '',
        address: '',
        remark: '',
        is_default: 0,
      },
      headerRules: {
        payee: [
          { required: true, message: '请输入收款人', trigger: 'blur' }
        ],
        bank_name: [
          { required: true, message: '请输入开户行', trigger: 'blur' }
        ],
        header: [
          { required: true, message: '请选择发票抬头', trigger: 'blur' }
        ],
      },
    }
  },
  methods: {
    // 编辑账号
    handleEditHeader() {
      // 验证form表单
      this.$refs.header.validate(valid => {
        if (valid) {
          this.loading = true
          const _header = JSON.parse(JSON.stringify(this.header))
          saveHeader(_header).then(response => {
            this.loading = false
            // 关闭窗口
            this.handleClose()
            // 触发父组件的callback事件
            this.$emit('getList')
            // 弹出操作提示
            this.$message({
              type: 'success',
              message: '保存成功!'
            })
          }).catch(() => {
            this.loading = false
          })
        }
      })
    },
    // 关闭窗口
    handleClose() {
      if (this.$refs.header) {
        this.$refs.header.resetFields()
      }
      // 更新visible参数
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped></style>